import {UrlUtility} from "./UrlUtility";

export let ApiUtility = {
    login: function (username, password) {
        return new Promise(function (resolve, reject) {
            fetch(
                '/api/users/login',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: username,
                        password: password
                    })
                }
            )
                .then(function (rawResponse) {
                    if (rawResponse.status === 401 || rawResponse.status === 404 || rawResponse.status === 500) {
                        throw new Error((rawResponse.statusText));
                    } else {
                        return rawResponse.json();
                    }
                })
                .then(function (responseData) {
                    resolve(responseData);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    apiRequest: function (url, options) {
        // fetch from API
        let extendedHeaders = (options && options.headers) || {};
        return new Promise(function (resolve, reject) {
            fetch(
                url,
                {
                    ...(options || {}),
                    headers: extendedHeaders
                }
            )
                .then(function (rawResponse) {
                    if (rawResponse.status === 401) {
                        window.location.assign('/login');
                    } else if (rawResponse.status === 404 || rawResponse.status === 500) {
                        throw new Error((rawResponse.statusText));
                    } else {
                        return rawResponse.json();
                    }
                })
                .then(function (responseData) {
                    resolve(responseData);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    logout: function () {
        return ApiUtility.apiRequest(`/api/users/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    getIsPersonEmailAvailable: function (email) {
        return ApiUtility.apiRequest(`/api/users/is-person-email-available/${encodeURIComponent(email)}`);
    },

    getUsersList: function (pageNumber, searchText) {
        let argumentsArray = [];

        if (pageNumber) {
            argumentsArray.push({label: 'page', value: pageNumber})
        }

        if (searchText) {
            argumentsArray.push({label: 'searchText', value: searchText})
        }

        return ApiUtility.apiRequest(
            `/api/users${UrlUtility.getUrlQueryString(argumentsArray)}`
        );
    },

    getUser: function (userId) {
        return ApiUtility.apiRequest(`/api/users/${userId}`);
    },

    createUser: function (userData) {
        return ApiUtility.apiRequest(
            '/api/users/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData),
            }
        );
    },

    updateUser: function (userData) {
        return ApiUtility.apiRequest(
            `/api/users/${userData.id}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            }
        );
    },

    getRolesList: function () {
        return ApiUtility.apiRequest('/api/roles');
    },

    getDefaultInvoiceSettingsUrl: function () {
        return ApiUtility.apiRequest('/api/invoices/get-default-invoice-settings-url')
    },

    getInvoicesList: function (pageNumber) {
        let argumentsArray = [];

        if (pageNumber) {
            argumentsArray.push({label: 'page', value: pageNumber})
        }

        return ApiUtility.apiRequest(
            `/api/invoices${UrlUtility.getUrlQueryString(argumentsArray)}`
        );
    },

    getInvoice: function (invoiceId) {
        return ApiUtility.apiRequest(`/api/invoices/${invoiceId}`);
    },

    getInvoiceByFpId: function (fpInvoiceId) {
        return ApiUtility.apiRequest(`/api/invoices/by-ext-fp-invoice-id/${fpInvoiceId}`);
    },

    getFpInvoiceForSubscription: function (fpInvoiceId) {
        return ApiUtility.apiRequest(`/api/invoices/fp-invoice-for-subscription/${fpInvoiceId}`);
    },

    billInvoice: function (invoiceData) {
        return ApiUtility.apiRequest(
            '/api/invoices/bill/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(invoiceData)
            }
        );
    },

    syncFpServices: function () {
        return ApiUtility.apiRequest(
            `/api/fp-services/sync`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );

    },

    syncInvoice: function (invoiceId) {
        return ApiUtility.apiRequest(
            `/api/invoices/sync/${invoiceId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },

    getQboAccountsList: function () {
        return ApiUtility.apiRequest('/api/qbo-accounts');
    },

    getFpServiceTypesList: function () {
        return ApiUtility.apiRequest('/api/fp-service-types');
    },

    getFpServicesForType: function (fpServiceTypeId) {
        return ApiUtility.apiRequest(`/api/fp-services/for-service-type/${fpServiceTypeId}`);
    },

    updateFpServicesForType: function (fpServicesData, fpServiceTypeId) {
        return ApiUtility.apiRequest(
            `/api/fp-services/for-service-type/${fpServiceTypeId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(fpServicesData)
            }
        );
    },

    getFpServiceType: function (id) {
        return ApiUtility.apiRequest(`/api/fp-service-types/${id}`);
    },

    updateFpServiceType: function (fpServiceTypeData) {
        return ApiUtility.apiRequest(
            `/api/fp-service-types/${fpServiceTypeData.id}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(fpServiceTypeData)
            }
        );
    },

    getInvoicePaymentSettings: function () {
        return ApiUtility.apiRequest('/api/invoice-payment-settings');
    },

    updateInvoicePaymentSettings: function (invoicePaymentSettingsData) {
        return ApiUtility.apiRequest(
            '/api/invoice-payment-settings',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(invoicePaymentSettingsData)
            }
        );
    },

    addTestFullStripeInvoicePayment: function (invoiceId) {
        return ApiUtility.apiRequest(
            `/api/invoices/add-test-full-stripe-invoice-payment/${invoiceId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },


    addTestFullQboInvoicePayment: function (invoiceId) {
        return ApiUtility.apiRequest(
            `/api/invoices/add-test-full-qbo-invoice-payment/${invoiceId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },

    addTestPartialQboInvoicePayment: function (invoiceId) {
        return ApiUtility.apiRequest(
            `/api/invoices/add-test-partial-qbo-invoice-payment/${invoiceId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },

    getSubscriptionInvoicesList: function (pageNumber) {
        let argumentsArray = [];

        if (pageNumber) {
            argumentsArray.push({label: 'page', value: pageNumber})
        }

        return ApiUtility.apiRequest(
            `/api/subscription-invoices${UrlUtility.getUrlQueryString(argumentsArray)}`
        );
    },

    getSubscriptionsList: function (pageNumber) {
        let argumentsArray = [];

        if (pageNumber) {
            argumentsArray.push({label: 'page', value: pageNumber})
        }

        return ApiUtility.apiRequest(
            `/api/subscriptions${UrlUtility.getUrlQueryString(argumentsArray)}`
        );
    },

    createSubscription: function (subscriptionData) {
        return ApiUtility.apiRequest(
            '/api/subscriptions/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(subscriptionData),
            }
        );
    },

    getStripeCustomersList: function (extFpCompanyId) {
        let argumentsArray = [];

        if (extFpCompanyId) {
            argumentsArray.push({label: 'extFpCompanyId', value: extFpCompanyId})
        }

        return ApiUtility.apiRequest(`/api/stripe-customers${UrlUtility.getUrlQueryString(argumentsArray)}`);
    },

    getQboCustomersList: function (extFpCompanyId) {
        let argumentsArray = [];

        if (extFpCompanyId) {
            argumentsArray.push({label: 'extFpCompanyId', value: extFpCompanyId})
        }

        return ApiUtility.apiRequest(`/api/qbo-customers${UrlUtility.getUrlQueryString(argumentsArray)}`);
    },

    getFpServicesList: function () {
        return ApiUtility.apiRequest('/api/fp-services');
    },

    getSubscription: function (subscriptionId) {
        return ApiUtility.apiRequest(`/api/subscriptions/${subscriptionId}`);
    },

    getSubscriptionBillingPeriods: function () {
        return ApiUtility.apiRequest(`/api/subscription-billing-periods`);
    },

    syncSubscriptionInvoices: function (subscriptionId) {
        return ApiUtility.apiRequest(
            `/api/subscriptions/sync-invoices/${subscriptionId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },

    syncAllSubscriptionInvoices: function () {
        return ApiUtility.apiRequest(
            `/api/subscriptions/sync-all-invoices`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
    },

    getIsInvoiceNumberAvailable: function (invoiceNumber) {
        return ApiUtility.apiRequest(`/api/invoices/is-number-available/${encodeURIComponent(invoiceNumber)}`);
    },

    createStripeCustomer: function (customerData) {
        return ApiUtility.apiRequest(
            '/api/stripe-customers/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(customerData),
            }
        );
    },

    getIsStripeCustomerEmailAvailable: function (email) {
        return ApiUtility.apiRequest(`/api/stripe-customers/is-email-available/${encodeURIComponent(email)}`);
    },

    createQboCustomer: function (customerData) {
        return ApiUtility.apiRequest(
            '/api/qbo-customers/',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(customerData),
            }
        );
    },

    getIsQboCustomerEmailAvailable: function (email) {
        return ApiUtility.apiRequest(`/api/qbo-customers/is-email-available/${encodeURIComponent(email)}`);
    },

    getIsQboCustomerNameAvailable: function (name) {
        return ApiUtility.apiRequest(`/api/qbo-customers/is-name-available/${encodeURIComponent(name)}`);
    },
};
